import { css } from "@emotion/react";

export const root = css`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 15px;
  padding-bottom: 15px;
  position: relative;
  flex-grow: 1;
  min-width: 0;
`;

export const subHeaderContainer = ({
  hasScrolled,
}: {
  hasScrolled: boolean;
}) => css`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin-bottom: ${hasScrolled ? "10px" : "0px"};
`;

export const body = ({ hasScrolled }: { hasScrolled: boolean }) => [
  css`
    position: relative;
    display: flex;
    flex-direction: row;
    min-height: 0;
    gap: 15px;
    padding-left: 15px;
    padding-right: 15px;
    overflow: auto;
    flex-grow: 1;
  `,
  !hasScrolled &&
    css`
      padding-top: 10px;
    `,
];
